import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    initials: 'MG',
    name: 'Marcela G.',
    loc: '📍 Roma | Docente di Fisica',
    quote: "Finalmente un materiale che parla la lingua della nostra scuola. Ho organizzato la programmazione annuale in un paio d'ore. Non avrei mai pensato che un materiale potesse essere così completo."
  }, {
    initials: 'LP',
    name: 'Laura P.',
    loc: '📍 Milano | Docente di Fisica',
    quote: 'Le mie lezioni hanno finalmente una struttura solida. Non devo più impazzire a cercare esercizi online la domenica sera. Avere tutto pronto mi ha restituito il mio tempo libero.'
  }, {
    initials: 'RM',
    name: 'Roberto M.',
    loc: '📍 Napoli | Docente di Fisica',
    quote: 'Non sono più arrivato in classe impreparato. Il Laboratorio Impossibile mi ha salvato la vita in una scuola senza fondi. I ragazzi si divertono e imparano con materiali poveri.'
  }, {
    initials: 'CR',
    name: 'Cecilia R.',
    loc: '📍 Torino | Docente di Scienze',
    quote: 'Ho preso il Combo Scienze. Insegno entrambe le materie e avere tutto coordinato è un sogno. La Banca delle Spiegazioni Chiare ha cambiato il modo in cui i miei alunni comprendono i concetti difficili.'
  }, {
    initials: 'FL',
    name: 'Fernando L.',
    loc: '📍 Bologna | Docente di Fisica',
    quote: 'I ragazzi sono molto più attenti. Le analogie della Banca delle Spiegazioni funzionano davvero. Quello che apprezzo di più è che è tutto organizzato per anno scolastico.'
  }, {
    initials: 'VT',
    name: 'Valeria T.',
    loc: '📍 Firenze | Docente di Fisica',
    quote: 'Le verifiche già pronte con le soluzioni mi fanno risparmiare almeno 3 ore a settimana. È come avere un collega esperto che ha già fatto tutto il lavoro pesante per me.'
  }];
  return <section className="bg-brand-dark py-32 px-4 border-t border-brand-border" data-id="element-268">
      <div className="max-w-6xl mx-auto" data-id="element-269">
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-center text-white mb-20 max-w-4xl mx-auto leading-tight" data-id="element-270">
          QUELLO CHE DICONO I DOCENTI CHE HANNO GIÀ{' '}
          <span className="text-brand-accent" data-id="element-271">FISICA PRONTA:</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-272">
          {testimonials.map((test, i) => <div key={i} className="bg-brand-card rounded-3xl p-10 border border-brand-border" data-id="element-273">
              <div className="flex items-center gap-5 mb-8" data-id="element-274">
                <div className="w-16 h-16 rounded-full bg-brand-accent/10 border border-brand-accent/20 flex items-center justify-center font-heading font-bold text-brand-accent text-2xl flex-shrink-0" aria-hidden="true" data-id="element-275">
                  {test.initials}
                </div>
                <div data-id="element-276">
                  <div className="text-brand-accent mb-2 text-sm" aria-label="5 estrellas" data-id="element-277">
                    ⭐⭐⭐⭐⭐
                  </div>
                  <p className="font-bold text-white text-xl mb-1" data-id="element-278">
                    {test.name}
                  </p>
                  <p className="text-sm text-white/70 font-medium" data-id="element-279">
                    {test.loc}
                  </p>
                </div>
              </div>
              <blockquote className="text-white/80 italic leading-relaxed text-lg" data-id="element-280">
                "{test.quote}"
              </blockquote>
            </div>)}
        </div>
      </div>
    </section>;
}